import { sendDataLayerEvent } from './google-analytics-v2';

export const dataLayerGA = {
  submitFormSuccess() {
    sendDataLayerEvent({
      event: 'Question Form Event',
      ga_event_name: 'ai_form_submit',
    });
  },
  downloadFileClick() {
    sendDataLayerEvent({
      event: 'AI Editor Event',
      ga_event_name: 'ai_editor_click_download',
    });
  },
  copyTextClick() {
    sendDataLayerEvent({
      event: 'AI Editor Event',
      ga_event_name: 'ai_editor_click_copy_text',
    });
  },
  newQuestionClick() {
    sendDataLayerEvent({
      event: 'AI Editor Event',
      ga_event_name: 'ai_editor_click_to_new_question',
    });
  },
  generateNextText(eventContext: string) {
    sendDataLayerEvent({
      event: 'AI Editor Event',
      ga_event_name: 'ai_editor_click_to_regenerate',
      event_context: eventContext,
    });
  },
  openGraphPopup() {
    sendDataLayerEvent({
      event: 'Answer Page Event',
      ga_event_name: 'answer_page_desmos_modal_impression',
    });
  },
  clickKatexExpression() {
    sendDataLayerEvent({
      event: 'Answer Page Event',
      ga_event_name: 'answer_page_desmos_click_to_open',
    });
  },
  featureBannerClick(subjectGroup: string | undefined) {
    sendDataLayerEvent({
      event: 'Answer Page Event',
      ga_event_name: 'answer_page_subscription_banner_cta',
      event_context: subjectGroup,
    });
  },
  solutionToolClick(toolName: string) {
    sendDataLayerEvent({
      event: 'Answer Page Event',
      ga_event_name: 'answer_page_recommended_tools_click',
      event_context: toolName,
    });
  },
};
